import {
    CREATE_DYEING_DC_DETAILS_FAILURE_DK,
    CREATE_DYEING_DC_DETAILS_REQUEST_DK,
    CREATE_DYEING_DC_DETAILS_SUCCESS_DK,
    CREATE_USER_FORM_DYEING_DC_DETAILS_DK,
    DELETE_DYEING_DC_DETAILS_FAILURE_DK,
    DELETE_DYEING_DC_DETAILS_REQUEST_DK,
    DELETE_DYEING_DC_DETAILS_SUCCESS_DK,
    FETCH_SINGLE_DYEING_DC_DETAILS_FAILURE_DK,
    FETCH_SINGLE_DYEING_DC_DETAILS_REQUEST_DK,
    FETCH_SINGLE_DYEING_DC_DETAILS_SUCCESS_DK,
    FETCH_DYEING_DC_DETAILS_FAILURE_DK,
    FETCH_DYEING_DC_DETAILS_REQUEST_DK,
    FETCH_DYEING_DC_DETAILS_SUCCESS_DK,
    DYEING_DC_DETAILS_USERFORM_RESET_DK,
    UPDATE_DYEING_DC_DETAILS_FAILURE_DK,
    UPDATE_DYEING_DC_DETAILS_REQUEST_DK,
    UPDATE_DYEING_DC_DETAILS_SUCCESS_DK,
    FETCH_DYEING_DC_DETAILS_BY_ID_REQUEST_DK,
    FETCH_DYEING_DC_DETAILS_BY_ID_SUCCESS_DK,
    FETCH_DYEING_DC_DETAILS_BY_ID_FAILURE_DK,
    FETCH_DYEING_DC_PREVIOUS_LIST_REQUEST_DK,
    FETCH_DYEING_DC_PREVIOUS_LIST_SUCCESS_DK,
    FETCH_DYEING_DC_PREVIOUS_LIST_FAILURE_DK,
    FETCH_DYEING_DC_DETAILS_DC_NO_REQUEST_DK,
    FETCH_DYEING_DC_DETAILS_DC_NO_SUCCESS_DK,
    FETCH_DYEING_DC_DETAILS_DC_NO_FAILURE_DK,
    FETCH_GRN_NO_BY_DYEING_DC_NO_REQUEST_DK,
    FETCH_GRN_NO_BY_DYEING_DC_NO_SUCCESS_DK,
    FETCH_GRN_NO_BY_DYEING_DC_NO_FAILURE_DK,
    FETCH_DYEING_DC_DETAILS_PROGRAM_LIST_REQUEST_DK,
    FETCH_DYEING_DC_DETAILS_PROGRAM_LIST_SUCCESS_DK,
    FETCH_DYEING_DC_DETAILS_PROGRAM_LIST_FAILURE_DK
} from './dyeingDCDetails.actionsType';

export const DYEING_DC_DETAILS_DK = 'dyeingDcDetailsDK';

let initialState = {
    loading: false,
    dyeingDCDetailsById: [],
    dyeingDCDetails: [],
    dyeingDCDetailsDcNo: [],
    previousList: [],
    programList: {},
    grnNoByDyeingDcNo: [],
    userform: {
        fldRate: 0,
        fldQuantity: 0,
        fldFKGSM: 0,
        fldGrossValue: 0,
        fldDiscountValue: 0,
        fldIGSTValue: 0,
        fldSGSTValue: 0,
        fldCGSTValue: 0,
        fldTaxableValue: 0,
        fldGSTValue: 0,
        fldSGSTPercentage: 0,
        fldCGSTPercentage: 0,
        fldIGSTPercentage: 0
    },
    selectedDyeingDCDetails: {},
    errorMessage: '',
    iperrorMessage: ''
};

export let dyeingDCDetailsDKReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;
    switch (type) {
        case FETCH_DYEING_DC_DETAILS_REQUEST_DK:
        case FETCH_GRN_NO_BY_DYEING_DC_NO_REQUEST_DK:
        case FETCH_DYEING_DC_DETAILS_DC_NO_REQUEST_DK:
        case FETCH_DYEING_DC_PREVIOUS_LIST_REQUEST_DK:
        case FETCH_DYEING_DC_DETAILS_BY_ID_REQUEST_DK:
        case CREATE_DYEING_DC_DETAILS_REQUEST_DK:
        case FETCH_SINGLE_DYEING_DC_DETAILS_REQUEST_DK:
        case UPDATE_DYEING_DC_DETAILS_REQUEST_DK:
        case DELETE_DYEING_DC_DETAILS_REQUEST_DK:
        case FETCH_DYEING_DC_DETAILS_PROGRAM_LIST_REQUEST_DK:
            return {
                ...state,
                loading: true
            };
        case FETCH_DYEING_DC_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                dyeingDCDetails: updatePayload
            };
        case FETCH_GRN_NO_BY_DYEING_DC_NO_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                grnNoByDyeingDcNo: updatePayload?.Inward
            };
        case FETCH_DYEING_DC_DETAILS_DC_NO_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                dyeingDCDetailsDcNo: updatePayload?.DYD
            };
        case FETCH_DYEING_DC_PREVIOUS_LIST_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                previousList: updatePayload
            };
        case FETCH_DYEING_DC_DETAILS_BY_ID_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                dyeingDCDetailsById: updatePayload
            };
        case FETCH_DYEING_DC_DETAILS_PROGRAM_LIST_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                programList: updatePayload
            };
        case CREATE_DYEING_DC_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                userform: {
                    fldFKAgentName: state?.userform?.fldFKAgentName,
                    fldFKMillName: state?.userform?.fldFKMillName,
                    fldRate: 0,
                    fldQuantity: 0,
                    fldFKGSM: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0
                }
            };
        case FETCH_SINGLE_DYEING_DC_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                selectedDyeingDCDetails: updatePayload[0],
                userform: updatePayload[0]
            };
        case UPDATE_DYEING_DC_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                selectedDyeingDCDetails: {},
                userform: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldFKGSM: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0
                }
            };
        case DELETE_DYEING_DC_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                userform: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldFKGSM: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0
                },
                selectedDyeingDCDetails: {}
            };

        case FETCH_DYEING_DC_DETAILS_FAILURE_DK:
        case FETCH_GRN_NO_BY_DYEING_DC_NO_FAILURE_DK:
        case FETCH_DYEING_DC_DETAILS_DC_NO_FAILURE_DK:
        case FETCH_DYEING_DC_PREVIOUS_LIST_FAILURE_DK:
        case FETCH_DYEING_DC_DETAILS_BY_ID_FAILURE_DK:
        case FETCH_SINGLE_DYEING_DC_DETAILS_FAILURE_DK:
        case CREATE_DYEING_DC_DETAILS_FAILURE_DK:
        case UPDATE_DYEING_DC_DETAILS_FAILURE_DK:
        case DELETE_DYEING_DC_DETAILS_FAILURE_DK:
        case FETCH_DYEING_DC_DETAILS_PROGRAM_LIST_FAILURE_DK:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_DYEING_DC_DETAILS_DK:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            };
        case DYEING_DC_DETAILS_USERFORM_RESET_DK:
            return {
                ...state,
                userform: {
                    fldFKAgentName: state?.userform?.fldFKAgentName,
                    fldFKMillName: state?.userform?.fldFKMillName,
                    fldRate: 0,
                    fldQuantity: 0,
                    fldFKGSM: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0
                },
                selectedDyeingDCDetails: {}
            };
        default:
            return state;
    }
};
